
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Layouts/SplitterPanel.html",
      function () {
        return require("private-next-pages/Layouts/SplitterPanel.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Layouts/SplitterPanel.html"])
      });
    }
  